<script setup lang="ts">
import { computed, watch } from 'vue'
import { useManagementStore } from '@/store/management'
import ForecastVsActualChart from './ForecastVsActualChart.vue'

// Gráfico previsto × realizado (acumulado) da área favorita no ano vigente,
// exibido no Painel. Buscar aqui também aquece o cache para o PDF.
const store = useManagementStore()

const year = new Date().getFullYear()
const area = computed(() => store.favoriteArea ?? store.roots[0] ?? null)
const data = computed(() => (area.value ? store.forecastVsActual[`${area.value.id}:all:${year}`] ?? null : null))

watch(
  () => area.value?.id,
  (id) => {
    if (id) store.fetchForecastVsActual(id, { year })
  },
  { immediate: true },
)
</script>

<template>
  <div v-if="area" class="flex flex-col gap-2">
    <h3 class="text-sm font-semibold uppercase tracking-wide text-slate-400">
      Previsto × Realizado · {{ area.name }} ({{ year }})
    </h3>
    <ForecastVsActualChart :data="data" default-mode="acumulado" />
  </div>
</template>
